import { useEffect, useState } from "react";
import Header from "../../Pages/Shared/Header";
import SubNavBar from "../../Pages/Shared/SubNavBar";
import { ToastContainer } from "react-toastify";

const MainLayoutSubmitter = ({ children }) => {
    const [showNav, setShowNav] = useState(false);
    useEffect(() => {
      console.log( window.location.pathname,"path");
      
      if (
        !window.location.pathname.includes("mainpage") &&
        window.location.pathname != "ResearchersAward"
      ) {
        // If the current page's path does NOT include 'mainpage'
        // AND the path is NOT exactly "/grants_/",
        // then show the navigation menu by setting `setShowNav` to `true`.
        setShowNav(true);
      } else {
        // Otherwise, hide the navigation menu by setting `setShowNav` to `false`.
        setShowNav(false);
      }
    }, [window.location.pathname]);

  return (
    <>
      <Header />
      {showNav ? <SubNavBar /> : <></>}
      <ToastContainer />
      <main>{children}</main>
    </>
  );
};
export default MainLayoutSubmitter;
